export const config = {
  apiUrl: process.env.REACT_APP_API_URL || '/api',
  socketUrl: process.env.REACT_APP_SOCKET_URL || window.location.origin,
};
